import withStyles from "@material-ui/core/styles/withStyles";
import { IStore } from "../store";
import * as React from "react";
import { RouteComponentProps } from "react-router";
import { Client } from "../api/model";
import { Theme, WithStyles, Paper, Grid, Typography, Divider, TextField, Button } from "@material-ui/core";
import { mockTheme, WithActions, bindActions } from "../utils/utils";
import { connect } from "react-redux";
import StoreModel from "../store/StoreModel";
import { ClientActions, ClientState } from "src/store/client";
import { Link } from "react-router-dom";

const styles = (theme: Theme) => ({
    root: {
    flexGrow: 1,
    },
});

const classesType = styles(mockTheme);

interface ClientPageProps
    extends RouteComponentProps<{ id: string }>,
    WithStyles<keyof typeof classesType>,
    WithActions<ClientActions> {
        actions: ClientActions;
        client: ClientState;
}

interface ClientPageState {
    data: Client;
}

class ClientPage extends React.Component<ClientPageProps, ClientPageState> {

    constructor(props: ClientPageProps) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.renderClient= this.renderClient.bind(this);
        this.handleRenew= this.handleRenew.bind(this);
    }

    componentDidMount(): void {
        this.handleRenew();
    }

    handleSubmit(event: any) {
        event.preventDefault();
        this.props.actions!.update(this.state.data);
        this.props.history.goBack();
    }

    handleRenew() {
        const id= parseInt(this.props.match.params.id, 10);
        this.props.actions.fetchById(id);
        if (this.props.client.dataClient.data) {
            console.info("Actualizando state: ", this.props.client.dataClient.data)
            this.setState({data: this.props.client.dataClient.data})
        }
    }

    handleChange(campo: string, dato: any, user: boolean= false) {
        let result;
        if (user) {
            result = {
                data: {
                    ...this.state.data,
                    user: {
                        ...this.state.data.user,
                        [campo]: dato
                    }
                }
            };
        } else {
            result= {
                data: {
                    ...this.state.data,
                    [campo]: dato
                }
            };
        }
        console.log("Cambio: ", dato, campo, this.state, result);
        this.setState(result);
    }


    renderClient(cliente: Client) {
        return (
            <div>
                <h1>Informacion del cliente</h1>
                <Divider/>
                <form noValidate onSubmit={this.handleSubmit}>
                    <Grid container direction="column">
                        <Grid item>
                            <TextField
                                id= "documento"
                                label="Documento"
                                value={cliente.document ? cliente.document : ""}
                                margin="normal"
                                fullWidth={true}
                                required
                                onChange={(e) => this.handleChange("document", e.target.value)}
                            />
                        </Grid>
                        <Grid item>
                            <TextField
                                id= "nombre"
                                label="Nombre"
                                value={cliente.user.name ? cliente.user.name : ""}
                                margin="normal"
                                fullWidth={true}
                                required
                                onChange={(e) => this.handleChange("name", e.target.value, true)}
                            />
                        </Grid>
                        <Grid item>
                            <TextField
                                id= "correo"
                                label="Correo"
                                value={cliente.user.email ? cliente.user.email : ""}
                                margin="normal"
                                fullWidth={true}
                                type="email"
                                required
                                onChange={(e) => this.handleChange("email", e.target.value, true)}
                            />
                        </Grid>
                        <Grid item>
                            <TextField
                                id= "telefono"
                                label="Telefono"
                                value={cliente.phone ? cliente.phone : ""}
                                margin="normal"
                                fullWidth={true}
                                type="tel"
                                onChange={(e) => this.handleChange("phone", e.target.value)}
                            />
                        </Grid>
                        {/* <Grid item>
                            <TextField
                                id= "observacion"
                                label="Observaciones"
                                value={cliente.observation ? cliente.observation : ""}
                                margin="normal"
                                fullWidth={true}
                                type="email"
                                onChange={(e) => this.handleChange("observation", e.target.value)}
                            />
                        </Grid> */}
                        <Grid item style={{display: 'flex', justifyContent: "space-around", margin: 10}}>
                            <Button type="submit" variant="contained" color="primary">Guardar cambios</Button>
                            <Button variant="contained" color="secondary" onClick={this.handleRenew}>Restaurar cambios</Button>
                        </Grid> 
                    </Grid>
                </form>
            </div>
        );
    }

    renderError() {
        const { classes } = this.props;
        return (
            <Grid container className={classes.root} spacing={16}>
                <Grid item sm={12}>
                    <Paper elevation={5} style={{ padding: 10 }}>
                        <Link to="/clients">Ir al Listado de clientes</Link>
                    </Paper>
                </Grid>
                <Grid item xs={12}>
                <Paper elevation={11} style={{ padding: 40, textAlign: "center" }}>
                    <Typography variant="display2" style={{ paddingBottom: 20 }}>
                    :(
                    </Typography>
                    <Typography variant="title">
                    El cliente que buscas no se ha podido cargar
                    </Typography>
                </Paper>
                </Grid>
            </Grid>
        );
    }

    render() {
        const { client } = this.props;

        if (client !== undefined) {
            if (StoreModel.isLoading(client.dataClient)) {
                return <div>Cargando...</div>;
            }
            if (StoreModel.isError(client.dataClient)) {
                this.renderError();
            }
    
            // return this.renderClient(client.dataClient.data!);
            if (client.dataClient.data !== null && this.state === null) {
                this.setState({data: client.dataClient.data});
            }
            return (
                <Grid container spacing={16}>
                    <Grid item sm={12}>
                        <Paper elevation={5} style={{ padding: 10 }}>
                            <Link to="/clients">Ir al Listado de clientes</Link>
                        </Paper>
                    </Grid>
                    <Grid item sm={12}>
                        <Paper elevation={5} style={{ padding: 10 }}>
                            {this.state && this.renderClient(this.state.data)}
                        </Paper>
                    </Grid>
                </Grid>
            );
        } else {
            return this.renderError();
        }
        
    }
}

const mapStateToProps = (state: IStore, ownProps: ClientPageProps) => ({
    ...ownProps,
    client: state.client
});

const styled = withStyles(styles as any)(ClientPage);
// const connected = connect(mapStateToProps, bindActions(ClientActions))(styled as any);
const connected = connect(mapStateToProps, bindActions(ClientActions))(styled as React.ComponentType);

export default connected as React.ComponentClass<Partial<ClientPageProps>>;



// WEBPACK FOOTER //
// ./src/pages/clientPage.tsx